import { Plugin } from 'ckeditor5';
import { CustomMentionsEditing } from './editing';
export class CustomMentions extends Plugin {
    static get pluginName() {
        return 'CustomMentions';
    }
    static get requires() {
        return [CustomMentionsEditing];
    }
}
